import {Component, computed, input} from '@angular/core';

@Component({
  selector: 'phx-table-skeleton',
  imports: [],
  templateUrl: './table-skeleton.component.html',
  styleUrl: './table-skeleton.component.scss'
})
export class TableSkeletonComponent {
  rows = input<number>(5);
  columns = input<number>(4);

  rowsArray = computed(() => Array(this.rows()).fill(0));
  columnsArray = computed(() => Array(this.columns()).fill(0));
}
